import { scaleLinear } from "d3-scale";
import { MiniPatternViewProps } from "../interfaces/Timeline";
import { Dance, DanceCouple } from "../interfaces/Choreography";

function MiniPatternView(props: MiniPatternViewProps) {
  const xScale = scaleLinear()
    .domain([-(props.danceFloor.width / 2), props.danceFloor.width / 2])
    .range([0, 64]);

  const yScale = scaleLinear()
    .domain([props.danceFloor.length / 2, -(props.danceFloor.length / 2)])
    .range([0, 64]);

  function getCircleFill(couple: DanceCouple, isGentleman: boolean): string {
    if (props.colorCodedCouples) {
      return props.coupleColors[couple.id].fillColor;
    }else {
      if (couple.joint) {
        return String(props.coupleColor);
      } else {
        if (isGentleman) {
          return String(props.gentlemanColor);
        }else {
          return String(props.ladyColor);
        }

      }
    }
  }


  return (
    <svg width={64} height={64}>
      {props.pattern.positions.map((danceCouple: DanceCouple) => (
        <g key={String(danceCouple.id)}>
          <circle
            cx={xScale(danceCouple.position[0].x)}
            cy={yScale(danceCouple.position[0].y)}
            r={2}
            fill={getCircleFill(danceCouple, true)}
          />
          <circle
            cx={xScale(danceCouple.position[1].x)}
            cy={yScale(danceCouple.position[1].y)}
            r={2}
            fill={getCircleFill(danceCouple, false)}
          />
        </g>
      ))}
    </svg>
  );
}

export default MiniPatternView;
